export const initHeroPlay = () => {
  console.log('initHeroPlay');
  const playBtn = document.querySelector('.hero-play-btn');
  const video = document.getElementById('hero-video');

  if (playBtn && video) {
    console.log(video.getAttribute('autoplay'));
    playBtn.addEventListener('click', () => {
      if (video.paused) {
        console.log('playing');
        video.play();
        playBtn.classList.add('playing');
      } else {
        console.log('paused');
        video.pause();
        playBtn.classList.remove('playing');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/templates/components/sustainability-hero/sustainability-hero.js